import React from 'react'
import {
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalTitle,
    WarningModalBackground,
    WarningModalContent,
} from '../../../components/ui/Modal';
import {ModalDefaultBtn, ModalActiveBtn} from "../../../components/ui/Button";
import {Caption4} from "../../../components/Font";
import {useTranslation} from "react-i18next";

export interface PasswordExpiryWarningProps {
    daysLeft: number
    onSkip: () => void
    onChangePassword: () => void
}

export const PasswordExpiryWarning = ({
                                          daysLeft,
                                          onSkip,
                                          onChangePassword
                                      }: PasswordExpiryWarningProps) => {
    const {t} = useTranslation();
    
    const getMessage = () => {
        if (daysLeft === 0) {
            return t('auth.passwordExpiryWarning.today');
        } else if (daysLeft === 1) {
            return t('auth.passwordExpiryWarning.tomorrow');
        } else {
            return t('auth.passwordExpiryWarning.daysLeft', { days: daysLeft });
        }
    };

    return <WarningModalBackground>
        <WarningModalContent>
            <ModalHeader>
                <ModalTitle>
                    {t('auth.passwordExpiryWarning.title')}
                </ModalTitle>
            </ModalHeader>
            <ModalBody>
                <Caption4>
                    {getMessage()}
                </Caption4>
                <Caption4 style={{marginTop: '12px'}}>
                    {t('auth.passwordExpiryWarning.recommendation')}
                </Caption4>
            </ModalBody>
            <ModalFooter>
                <ModalDefaultBtn onClick={onSkip}>
                    {t('auth.passwordExpiryWarning.skip')}
                </ModalDefaultBtn>
                <ModalActiveBtn onClick={onChangePassword}>
                    {t('auth.passwordExpiryWarning.changePassword')}
                </ModalActiveBtn>
            </ModalFooter>
        </WarningModalContent>
    </WarningModalBackground>
}

